import { createMutation, createQuery } from 'react-query-kit';

import { queryClient } from 'services/http/queryClient';
import portalSchema from 'support/types/schema-portal';

import { fetchData, patchData } from '../../http/http';

export type SsccConfiguration = portalSchema.components['schemas']['PartnerSsccConfiguration'];

export type UpdateSsccConfigurationPayload =
  portalSchema.paths['/v1/partners/current/sscc']['patch']['requestBody']['content']['application/json'];

type GetSsccConfigurationResponse =
  portalSchema.paths['/v1/partners/current/sscc']['get']['responses']['200']['content']['application/json'];

type UpdateSsccConfigurationResponse =
  portalSchema.paths['/v1/partners/current/sscc']['patch']['responses']['200']['content']['application/json'];

export const useSsccConfiguration = createQuery<SsccConfiguration, void, Error>({
  primaryKey: '/partners/current/sscc',
  queryFn: async () => {
    const { data } = await fetchData<GetSsccConfigurationResponse>('/v1/partners/current/sscc');
    return data.data;
  },
});

export const useUpdateSsccConfiguration = createMutation<SsccConfiguration, UpdateSsccConfigurationPayload, Error>({
  mutationFn: async (payload) => {
    const { data } = await patchData<UpdateSsccConfigurationResponse>('/v1/partners/current/sscc', payload);
    return data.data;
  },
  onSuccess: () => {
    queryClient.invalidateQueries({ queryKey: useSsccConfiguration.getKey() });
  },
});
